import { useEffect } from "react";
import { Formik, FormikInsurance } from "src/types";
import { useBoolean } from "src/utils";

export const useScrollToError = ({ errors }: Formik<FormikInsurance>) => {
  const [toCheck, startCheck, stopCheck] = useBoolean();

  useEffect(() => {
    if (toCheck) {
      stopCheck();

      let errKey = Object.keys(errors)[0];
      const topLevel = errors[errKey as keyof typeof errors];

      if (Array.isArray(topLevel) && topLevel.length > 0) {
        //list (e.g. insuredList)
        
        //Tipo di comodo
        type Row = Record<string, unknown> | undefined;

        // findIndex salta i posti vuoti
        const i = (topLevel as Row[]).findIndex(
          (v): v is Record<string, unknown> =>
            v !== undefined && v !== null && typeof v === "object"
        );

        if (i !== -1) {
          const obj = (topLevel as Record<string, unknown>[])[i];
          const subKey = Object.keys(obj)[0];
          if (subKey) {
            errKey = `${errKey}.${i}.${subKey}`;
          }
        }
      } else if (typeof topLevel === "object" && topLevel !== null) {
        //Object (e.g. contractor)
        const subKey = Object.keys(topLevel)[0];
        errKey = `${errKey}.${subKey}`;
      }

      if (errKey) {
        if (errKey === "insuredPeriodType") {
          window.scroll(0, 0);
        }
        document?.getElementById(`input-${errKey}`)?.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      }
    }
  }, [errors, toCheck]);

  const triggerFormikCheck = startCheck;

  return { triggerFormikCheck };
};
